import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebase-config";

export default function SuperbadgesList() {
    const [total, setTotal] = useState(0);
    const [mostRecent, setMostRecent] = useState(null)
    // const [superbadges, setSuperbadges] = useState([]);

    useEffect(() => {
        const fetchSuperbadges = async () => {
        const snapshot = await getDocs(collection(db, "superbadges"));
        const data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        // setSuperbadges(data);

        // total count
        setTotal(data.length);

        // most recent badge
        const valid = data.filter(badge => badge.completed);
        
        const sorted = valid
            .slice()
            // .sort((a,b) => new Date(b.completed) - new Date(a.completed));
            .sort((a,b) => b.completed.toDate() - a.completed.toDate());

            setMostRecent(sorted[0] || null);
        };
        fetchSuperbadges();
        
    }, []);

    return (
        <section className="superbadgesList card">
            <h3>Superbadges</h3>

            <Link to="/Superbadges">
                {mostRecent && (
                    <p>Most recent: {mostRecent.name}</p>
                )}

                <p>Total earned: {total}</p>

                {/* <ul>
                    {superbadges.map(badge => (
                    <li key={badge.id}>{badge.name}</li>
                    ))}
                </ul> */}
            </Link>        
        </section>
    );
    }
